export enum BillReceiverEndpointType {
    EAN = "EAN",
    EMAIL = "EMAIL",
}

export interface BillReceiverEndpoint {
    type: BillReceiverEndpointType
    ean?: string
    email?: string
}

export interface BillReceiverAddress {
    displayName: string
    country?: {
        countryCode: string
    }
    postalCode?: string
    city?: string
    addressLines?: string[]
}

export interface BillReceiverContact {
    name?: string
    email?: string
    phoneNumber?: string
}

export interface BillReceiver {
    id: number
    type: string
    vatnumber: string
    debitorNo?: string
    name: string
    address: BillReceiverAddress
    endpoint: BillReceiverEndpoint
    contactDetails?: BillReceiverContact
    isActive: boolean
}

// Update bill receiver types
export interface UpdateBillReceiverAddress {
    country: {
        countryCode: string
    }
    postalCode: string
    city: string
    addressLines: string[]
}

export interface UpdateBillReceiverEndpoint {
    type: BillReceiverEndpointType
    ean?: string
    email?: string
}

export interface UpdateBillReceiverContact {
    name: string
    email: string
    phoneNumber: string
}

export interface UpdateBillReceiverPayload {
    billReceiver: {
        type: string
        vatnumber?: string
        debitorNo?: string
        name: string
        address: UpdateBillReceiverAddress
        endpoint: UpdateBillReceiverEndpoint
        isActive: boolean
        contactDetails?: UpdateBillReceiverContact
    }
    onBehalfOf?: {
        userId: number
    }
}
